__turbopack_context__.v({
  "cardBase": "sPpPFG_cardBase",
  "content": "sPpPFG_content",
  "date": "sPpPFG_date",
  "emptyCard": "sPpPFG_emptyCard" + " " + "sPpPFG_cardBase",
  "emptyDescription": "sPpPFG_emptyDescription",
  "emptyIcon": "sPpPFG_emptyIcon",
  "field": "sPpPFG_field" + " " + "sPpPFG_fieldBase",
  "fieldBase": "sPpPFG_fieldBase",
  "fieldRight": "sPpPFG_fieldRight" + " " + "sPpPFG_fieldBase",
  "fieldValue": "sPpPFG_fieldValue",
  "header": "sPpPFG_header",
  "row": "sPpPFG_row",
});
